class RenderComponentData {
	constructor() {
		this.enabled = true;
		this.rootBone = null;
	}
}

export { RenderComponentData };
